<div mat-dialog-title class="dialog-header">
  <div class="dialog-title">
    <mat-icon class="dialog-title-icon">extension</mat-icon>
    {{ manifest().name }}
    <span class="version-chip">&mdash; v{{ manifest().version }}</span>
  </div>
  <button mat-icon-button disableRipple (click)="onClose()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  @if (manifest().description) {
    <p class="module-description">{{ manifest().description }}</p>
  }

  @if (hasHelp()) {
    <div class="help-section">
      <p>{{ manifest().help }}</p>
    </div>
  }

  @if (manifest().author) {
    <div class="meta-row">
      <span class="meta-label">Author:</span>
      <span>{{ manifest().author }}</span>
    </div>
  }

  @if (manifest().license) {
    <div class="meta-row">
      <span class="meta-label">License:</span>
      <span>{{ manifest().license }}</span>
    </div>
  }

  <h3 class="section-title">
    Functions
    <span class="count-badge">{{ functions().length }}</span>
  </h3>

  <mat-accordion multi>
    @for (func of functions(); track func.name) {
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <code class="func-name">{{ func.name }}</code>
          </mat-panel-title>
          <mat-panel-description>
            {{ func.description ?? '' }}
          </mat-panel-description>
        </mat-expansion-panel-header>

        @if (func.help) {
          <p class="func-help">{{ func.help }}</p>
        }

        <!-- Inputs -->
        @if (func.inputs.length > 0) {
          <h4>Inputs</h4>
          <table class="params-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Required</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              @for (input of func.inputs; track input.name) {
                <tr>
                  <td><code>{{ input.name }}</code></td>
                  <td><mat-chip>{{ input.type }}</mat-chip></td>
                  <td>{{ input.required ? 'Yes' : 'No' }}</td>
                  <td>{{ input.description ?? '' }}</td>
                </tr>
              }
            </tbody>
          </table>
        }

        <!-- Outputs -->
        @if (func.outputs.length > 0) {
          <h4>Outputs</h4>
          <table class="params-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              @for (output of func.outputs; track output.name) {
                <tr>
                  <td><code>{{ output.name }}</code></td>
                  <td><mat-chip>{{ output.type }}</mat-chip></td>
                  <td>{{ output.description ?? '' }}</td>
                </tr>
              }
            </tbody>
          </table>
        }

        <!-- Code Examples -->
        <h4>Usage</h4>
        <mat-tab-group class="code-tabs">
          <mat-tab label="Python">
            <div class="code-wrapper">
              <pre class="code-block"><code>{{ pythonExample(func) }}</code></pre>
              <button mat-icon-button class="copy-btn" (click)="copyCode(pythonExample(func))" matTooltip="Copy">
                <mat-icon>content_copy</mat-icon>
              </button>
            </div>
          </mat-tab>
          <mat-tab label="JavaScript">
            <div class="code-wrapper">
              <pre class="code-block"><code>{{ jsExample(func) }}</code></pre>
              <button mat-icon-button class="copy-btn" (click)="copyCode(jsExample(func))" matTooltip="Copy">
                <mat-icon>content_copy</mat-icon>
              </button>
            </div>
          </mat-tab>
        </mat-tab-group>

        <!-- Manifest examples if present -->
        @if (func.examples && func.examples.length > 0) {
          <h4>Examples</h4>
          @for (example of func.examples; track $index) {
            @if (example.description) {
              <p class="example-desc">{{ example.description }}</p>
            }
            <div class="code-wrapper">
              <pre class="code-block"><code>{{ example.code }}</code></pre>
              <button mat-icon-button class="copy-btn" (click)="copyCode(example.code)" matTooltip="Copy">
                <mat-icon>content_copy</mat-icon>
              </button>
            </div>
          }
        }
      </mat-expansion-panel>
    }
  </mat-accordion>
</mat-dialog-content>

